/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Nav_TodayInputs */

const en_dashboard_nav_today = /** @type {(inputs: Dashboard_Nav_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Today`)
};

const pl_dashboard_nav_today = /** @type {(inputs: Dashboard_Nav_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzisiaj`)
};

/**
* | output |
* | --- |
* | "Today" |
*
* @param {Dashboard_Nav_TodayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const dashboard_nav_today = /** @type {((inputs?: Dashboard_Nav_TodayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Nav_TodayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_dashboard_nav_today(inputs)
	return en_dashboard_nav_today(inputs)
});